import { useState } from "react";
import {getLoansDetails, uploadLoanDocument} from "../../Api/Api";
import {useNotification} from "../Notification/NotificationContext";
// import axios from "../A";

const UploadDocumentModal = ({ loanId, onClose, handleSave }) => {
    const [file, setFile] = useState(null);
    const [type, setType] = useState("");
    const { showNotification } = useNotification();

    const documentTypes = [
        "HOUSE_FRONT", "HOUSE_INSIDE_1", "HOUSE_INSIDE_2",
        "FAMILY_PHOTO", "PAN_CARD", "AADHAR_FRONT", "AADHAR_BACK",
        "GUARANTOR_AADHAR_FRONT", "GUARANTOR_AADHAR_BACK", "GUARANTOR_PHOTO","PERSON_PHOTO","LOAN_AGREEMENT"
    ];

    const uploadDocument = async () => {
        if (!file || !type) return  showNotification("Please select file and type", "error");

        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", type);

        try {
            if(formData.get("type") === undefined){
                showNotification("Choose Document Type", "error")
            }
            else {
                handleSave(formData);
            }
            onClose();
        } catch (error) {
            showNotification(error.message, "error")
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-5 rounded-md">
                <h2 className="text-lg font-bold">Upload Document</h2>
                <select className="w-full p-2 border my-2" onChange={(e) => setType(e.target.value)}>
                    <option value="">Select Document Type</option>
                    {documentTypes.map(type => (
                        <option key={type} value={type}>{type.replace("_", " ")}</option>
                    ))}
                </select>
                <input type="file" onChange={(e) => setFile(e.target.files[0])} />
                <button className="bg-blue-500 text-white p-2 mt-2" onClick={uploadDocument}>
                    Upload
                </button>
                <button className="bg-red-500 text-white p-2 mt-2 ml-2" onClick={onClose}>
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default UploadDocumentModal;
